import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "../lib/i18n.tsx";

function SearchIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.5-3.5" />
    </svg>
  );
}

/** The one search box: in the top bar, at the bottom on phones, and big on the Search page. */
export function SearchBox({ big = false, initial = "", autoFocus = false }: { big?: boolean; initial?: string; autoFocus?: boolean }) {
  const nav = useNavigate();
  const [q, setQ] = useState(initial);
  useEffect(() => setQ(initial), [initial]);
  return (
    <form
      role="search"
      className={big ? "big-search" : "tb-search"}
      onSubmit={(e) => {
        e.preventDefault();
        if (q.trim()) nav(`/search?q=${encodeURIComponent(q.trim())}`);
      }}
    >
      <span className="ico"><SearchIcon /></span>
      <input
        type="search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder={big ? t("Part, PO or container, e.g. alto 9 bronze, 16802, CA-27013") : t("Search a part, PO or container")}
        aria-label="Search a part, PO or container"
        autoFocus={autoFocus}
      />
    </form>
  );
}
